"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downloadDishEvaluateList = downloadDishEvaluateList;
exports.downloadEvaluationList = downloadEvaluationList;
exports.downloadShopEvaluationList = downloadShopEvaluationList;
exports.getDishEvaluateList = getDishEvaluateList;
exports.getGoodEvaluateList = getGoodEvaluateList;
exports.getShopEvaluateList = getShopEvaluateList;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
function getDishEvaluateList(query) {
  return (0, _requestAuth.default)({
    url: '/xyOrderCommentScore/page',
    method: 'get',
    params: query
  });
}
function downloadDishEvaluateList(data) {
  return (0, _requestAuth.default)({
    url: '/xyOrderCommentScore/downloadList',
    method: 'post',
    data: data
  });
}
function getGoodEvaluateList(data) {
  return (0, _requestAuth.default)({
    url: '/xyOrderCommentScore/getGoodEvaluateList',
    method: 'post',
    data: data
  });
}
function getShopEvaluateList(data) {
  return (0, _requestAuth.default)({
    url: '/xyOrderComment/getShopEvaluateList',
    method: 'post',
    data: data
  });
}
function downloadShopEvaluationList(data) {
  return (0, _requestAuth.default)({
    url: '/xyOrderComment/downloadEvaluationList',
    method: 'post',
    data: data
  });
}
function downloadEvaluationList(data) {
  return (0, _requestAuth.default)({
    url: '/xyOrderCommentScore/downloadEvaluationList',
    method: 'post',
    data: data
  });
}